import { JobProgressionStepStatus } from 'jobs/progression/JobProgression'
import { JobProgressionContent } from 'messaging/models/Content'
import Message from 'messaging/models/Message'
import { computed, makeObservable } from 'mobx'

export default class JobProgressionMessageContentViewModel {
  constructor(
    private canUpdateJobProgressionAsClient: boolean,
    public readonly message: Message,
    public readonly onViewRejectDraft: () => void,
    public readonly onViewApproveDraft: () => void,
  ) {
    makeObservable(this)
  }

  dateFormatter = new Intl.DateTimeFormat('en-US', {
    dateStyle: 'long',
    timeStyle: 'medium',
  })

  @computed
  get canAnswerDraftInReviewMessage() {
    return (
      this.progressionStep?.status ===
        JobProgressionStepStatus.DRAFT_IN_REVIEW &&
      this.canUpdateJobProgressionAsClient
    )
  }

  @computed
  get progressionStep() {
    const content = this.message.content as JobProgressionContent
    return content?.progression?.steps?.find((s) => s.id === content?.stepId)
  }

  @computed
  get title() {
    switch (this.progressionStep?.status) {
      case JobProgressionStepStatus.DRAFT_APPROVED:
        return 'The return has been approved.'
      case JobProgressionStepStatus.DRAFT_REJECTED:
        return 'Changes have been requested'
      case JobProgressionStepStatus.DRAFT_IN_REVIEW:
        return 'The return is now ready for review'
      default:
        return ''
    }
  }

  @computed
  get description() {
    switch (this.progressionStep?.status) {
      case JobProgressionStepStatus.DRAFT_APPROVED:
      case JobProgressionStepStatus.DRAFT_REJECTED:
        return this.dateFormatter.format(this.progressionStep.dateCreated)
      case JobProgressionStepStatus.DRAFT_IN_REVIEW:
        return 'The return is now ready for review'
      default:
        return ''
    }
  }
}
